import { render } from "./TemplatesStatusView.vue?vue&type=template&id=5e5e4263&scoped=true"
import script from "./TemplatesStatusView.vue?vue&type=script&lang=js"
export * from "./TemplatesStatusView.vue?vue&type=script&lang=js"

import "./TemplatesStatusView.vue?vue&type=style&index=0&id=5e5e4263&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e5e4263"]])

export default __exports__